import * as types from './types'
// SET_PROTOCOL

export const GetProtocol = ({ commit }, data) => {
  commit(types.SET_PROTOCOL, data.protocol)
}
